// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

// ✅ Use env variable for backend URL (falls back to local dev)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const Footer = () => {
  // Check if user is a delivery agent
  const isDeliveryAgent = localStorage.getItem('deliveryAgentToken') || 
                         localStorage.getItem('deliveryAgentId');
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
            <li><Link to="/stores">Our Stores</Link></li>
            <li><Link to="/blog">Blog</Link></li>

            {/* ✅ Use env variable for backend URL */}
            <li>
              <a href={`${API_BASE_URL}/delivery/`}>Become a Delivery Partner</a>
            </li>

            {isDeliveryAgent && (
              <li>
                <a href={`${API_BASE_URL}/delivery/dashboard/`}>Delivery Dashboard</a>
              </li>
            )}

          </ul>
        </div>
        
        {/* Categories */}
        <div className="footer-section">
          <h4>Categories</h4>
          <ul className="footer-links">
            <li><Link to="/category/fruits-vegetables">Fruits & Vegetables</Link></li>
            <li><Link to="/category/dairy-eggs">Dairy & Eggs</Link></li>
            <li><Link to="/category/bakery">Bakery</Link></li>
            <li><Link to="/category/meat-seafood">Meat & Seafood</Link></li>
            <li><Link to="/category/beverages">Beverages</Link></li>
          </ul>
        </div>
        
        {/* Legal Links */}
        <div className="footer-section">
          <h4>Legal</h4>
          <ul className="footer-links">
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
            <li><Link to="/delivery-policy">Delivery Policy</Link></li>
            <li><Link to="/cookie-policy">Cookie Policy</Link></li>
          </ul>
        </div>
        
        {/* Contact Info */}
        <div className="footer-section">
          <h4>Contact Info</h4>
          <ul className="footer-links">
            <li>#3-36, Kadirinathunikota V&P ,AndhraPradesh</li>
            <li>+91-8008954694</li>
            <li>support@ressde.in</li>
          </ul>
          
          {/* ✅ Fixed social icons - use real URLs or proper aria-labels */}
          <div className="social-icons">
            <a 
              href="https://facebook.com" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a 
              href="https://pinterest.com" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Pinterest"
            >
              <i className="fab fa-pinterest"></i>
            </a>
          </div>
        </div>
        
        {/* Newsletter */}
        <div className="footer-section newsletter">
          <h4>Newsletter</h4>
          <p>Subscribe for updates and offers</p>
          <form>
            <input type="email" placeholder="Your Email Address" required />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2023 RessDe. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;